<div class="footer-nav-block">
    @for (column of columns; track column) {
    <h-footer-links-group [column]="column" (triggerToggle)="handleToggleColumn($event)"> </h-footer-links-group>
    }
</div>
